import { useThemeStore } from "@stores/theme.store";
import moment from "moment-timezone";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  LuBookMarked,
  LuBookOpen,
  LuCalendar,
  LuFileText,
  LuRepeat2,
} from "react-icons/lu";

moment.locale("id");

type InfoRowProps = { label: string; value: React.ReactNode };
const InfoRow = ({ label, value }: InfoRowProps) => (
  <div className="tw-flex tw-justify-between tw-items-start tw-py-2.5 tw-gap-3">
    <span className="tw-text-xs tw-text-text-secondary tw-shrink-0 tw-w-2/5">
      {label}
    </span>
    <span className="tw-text-sm tw-font-semibold tw-text-text-primary tw-text-right tw-flex-1">
      {value}
    </span>
  </div>
);

const Divider = () => (
  <div className="tw-h-px" style={{ background: "#f1f1f1" }} />
);

export const TahfidzDetailPage = () => {
  const { state } = useLocation();
  const { setHeader, setAppBar } = useThemeStore((s) => s);

  useEffect(() => {
    setAppBar({ title: "Detail Tahfidz", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Detail Tahfidz",
      image: false,
    });
  }, [setHeader, setAppBar]);

  return (
    <div className="tw-px-4 tw-pt-2 tw-pb-20 tw-space-y-3">
      {/* Hero card */}
      <div className="card-body tw-text-center tw-py-6">
        <div
          className="tw-inline-flex tw-items-center tw-justify-center tw-rounded-3xl tw-w-16 tw-h-16 tw-mb-4"
          style={{ background: "#f0fdf4" }}
        >
          <LuBookOpen className="tw-text-3xl tw-text-[#16a34a]" />
        </div>

        <div className="tw-text-lg tw-font-bold tw-text-text-primary tw-mb-2 tw-px-4">
          Tahfidz
        </div>

        <div className="tw-flex tw-items-center tw-justify-center tw-gap-1.5 tw-text-xs tw-text-text-secondary tw-mb-3">
          <LuCalendar className="tw-text-sm" />
          {moment(state?.tanggal ?? Date.now()).format("dddd, DD MMMM YYYY")}
        </div>

        {state?.nilai && (
          <div
            className="tw-inline-flex tw-items-center tw-px-3 tw-py-1 tw-rounded-full tw-text-xs tw-font-semibold"
            style={{
              background: "#f0fdf4",
              color: "#16a34a",
              border: "1.5px solid #bbf7d0",
            }}
          >
            Nilai: {state.nilai}
          </div>
        )}
      </div>

      {/* Detail card */}
      <div className="card-body">
        <div className="tw-flex tw-items-center tw-gap-2 tw-mb-3">
          <div className="tw-w-1 tw-h-4 tw-rounded-full tw-bg-primary" />
          <span className="tw-text-xs tw-font-bold tw-text-text-secondary tw-uppercase tw-tracking-widest">
            Rincian Hafalan
          </span>
        </div>

        <InfoRow
          label="Tambahan"
          value={
            <span className="tw-flex tw-items-center tw-justify-end tw-gap-1.5">
              <LuBookOpen className="tw-text-text-secondary tw-shrink-0" />
              {state?.tambahan || "-"} halaman
            </span>
          }
        />

        <Divider />
        <InfoRow
          label="Murojaah"
          value={
            <span className="tw-flex tw-items-center tw-justify-end tw-gap-1.5">
              <LuRepeat2 className="tw-text-text-secondary tw-shrink-0" />
              {state?.murojaah || "-"}
            </span>
          }
        />

        {state?.murojaahBaru && state.murojaahBaru !== "-" && (
          <>
            <Divider />
            <InfoRow
              label="Murojaah Baru"
              value={
                <span className="tw-flex tw-items-center tw-justify-end tw-gap-1.5">
                  <LuBookMarked className="tw-text-text-secondary tw-shrink-0" />
                  {state.murojaahBaru}
                </span>
              }
            />
          </>
        )}

        {state?.tambahanKeterangan && state.tambahanKeterangan !== "-" && (
          <>
            <Divider />
            <div className="tw-pt-2.5 tw-pb-1">
              <div className="tw-flex tw-items-center tw-gap-1.5 tw-mb-1.5">
                <LuFileText className="tw-text-sm tw-text-text-secondary" />
                <span className="tw-text-xs tw-text-text-secondary">
                  Keterangan
                </span>
              </div>
              <p className="tw-text-sm tw-font-semibold tw-text-text-primary tw-leading-relaxed">
                {state.tambahanKeterangan}
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
